import {
  Music,
  Music2,
  Guitar,
  Mic,
  Mic2,
  Headphones,
  Radio,
  Disc3,
  Volume2,
  Piano,
  Drum,
  Heart,
  Star,
  Sparkles,
  Award,
  Trophy,
  Medal,
  Crown,
  Gem,
  BadgeCheck,
  ShieldCheck,
  Target,
  Zap,
  Flame,
  Flag,
  ThumbsUp,
  PartyPopper,
  Users,
  GraduationCap,
  Calendar,
  Clock,
  MapPin,
  Globe,
  Building2,
  TrendingUp,
  ClipboardList,
  CheckCircle,
  BookOpen,
  Rocket,
  Lightbulb,
  Smile,
  Gift,
  Handshake,
  Megaphone,
  Newspaper,
  Palette,
  Clapperboard,
  Tv,
  Camera,
  Video,
  type LucideIcon,
} from 'lucide-react';

/**
 * Curated icon set shared by the CMS icon picker (Office) and the website
 * renderer. Keys are stable kebab-case names stored in content; keep this list
 * in sync with website/lib/cmsIcons.ts.
 */
export const CMS_ICONS: Record<string, LucideIcon> = {
  // Musik & Performance
  music: Music,
  music2: Music2,
  guitar: Guitar,
  mic: Mic,
  mic2: Mic2,
  headphones: Headphones,
  radio: Radio,
  disc: Disc3,
  volume: Volume2,
  piano: Piano,
  drum: Drum,
  // Erfolge & Auszeichnungen
  heart: Heart,
  star: Star,
  sparkles: Sparkles,
  award: Award,
  trophy: Trophy,
  medal: Medal,
  crown: Crown,
  gem: Gem,
  'badge-check': BadgeCheck,
  'shield-check': ShieldCheck,
  target: Target,
  zap: Zap,
  flame: Flame,
  flag: Flag,
  'thumbs-up': ThumbsUp,
  'party-popper': PartyPopper,
  // Medien & Casting
  clapperboard: Clapperboard,
  tv: Tv,
  camera: Camera,
  video: Video,
  newspaper: Newspaper,
  megaphone: Megaphone,
  // Allgemein
  users: Users,
  'graduation-cap': GraduationCap,
  calendar: Calendar,
  clock: Clock,
  'map-pin': MapPin,
  globe: Globe,
  building: Building2,
  'trending-up': TrendingUp,
  'clipboard-list': ClipboardList,
  'check-circle': CheckCircle,
  'book-open': BookOpen,
  rocket: Rocket,
  lightbulb: Lightbulb,
  smile: Smile,
  gift: Gift,
  handshake: Handshake,
  palette: Palette,
};

export const CMS_ICON_NAMES = Object.keys(CMS_ICONS);
